module.exports = __webpack_public_path__ + "img/bill.2c1e4823.jpg";